import React, { Component } from "react";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import { Row, Col } from "react-flexbox-grid";
import { TextField, Loadable, EntitySelector, If } from "components/support";
import { CNPJ } from "cpf_cnpj";

class FilterView extends Component {
  state = {
    name: "",
    email: "",
    company: { name: "", uuid: "" }
  };

  handleField = (field, value) => {
    const { onFilter } = this.props;
    this.setState({ [field]: value }, () => onFilter(this.state));
  };

  render() {
    const { loading, companySearchOptions } = this.props;
    const { name, email, company } = this.state;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md>
              <TextField
                allowClear
                fullWidth
                label="Nome"
                value={name}
                onChange={(_, value) => this.handleField("name", value)}
              />
            </Col>
            <Col xs={12} md>
              <TextField
                allowClear
                fullWidth
                label="E-mail"
                value={email}
                onChange={(_, value) => this.handleField("email", value)}
              />
            </Col>
            <If test={false}>
              <Col xs={12} md>
                <EntitySelector
                  allowClear
                  fullWidth
                  label="Empresa"
                  title="Selecionar Empresa"
                  value={company.name}
                  searchOptions={companySearchOptions}
                  onSelect={company => this.handleField("company", company)}
                  parser={company => ({
                    key: company.uuid,
                    title: company.slug,
                    subtext: company.fiscal_informations
                      ? CNPJ.format(company.fiscal_informations.cnpj)
                      : ""
                  })}
                  nullSelection={{ name: "", uuid: "" }}
                />
              </Col>
            </If>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default FilterView;



// WEBPACK FOOTER //
// ./src/components/app/registration/user/filter/index.jsx